import { render, staticRenderFns } from "./sidebar_detail_row.vue?vue&type=template&id=be6c664c&"
import script from "./sidebar_detail_row.vue?vue&type=script&lang=js&"
export * from "./sidebar_detail_row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sidebar_detail_row.vue"
export default component.exports